<template>
    <div class="icon-form-field-group">
        <label :for="id" class="icon-form-field-group__label" v-if="label">
            {{ label }}
        </label>
        <div :id="id" class="icon-form-field">
            <div class="icon-form-field__icon">
                <img class="icon-form-field__icon-image" :src="imageSource" />
            </div>
            <div class="icon-form-field__data">
                <uploader @uploadUrlUpdate="updateIconSrc"></uploader>
            </div>
            <div class="icon-form-field__help" v-if="help">{{ help }}</div>
        </div>
    </div>
</template>
<script>
import Uploader from "./Uploader";
export default {
    name: "icon-form-field",
    model: {
        prop: "icon",
        event: "change",
    },
    props: {
        icon: {type: Object, required: true},
        id: {
            default() {
                return `${this._uid}`;
            },
        },
        label: {type: String},
        help: {type: String},
    },
    components: {
        Uploader,
    },
    computed: {
        imageSource() {
            return this.iconData.src ? this.iconData.src : require("@/assets/images/logo.png");
        },
        hasSource() {
            return !!this.iconData.src;
        },
    },
    methods: {
        updateIconSrc(event) {
            this.$set(this.iconData, "src", event);
            this.$emit("change", this.iconData);
        },
    },
    data() {
        return {
            iconData: JSON.parse(JSON.stringify(this.icon)),
        };
    },
};
</script>
<style lang="scss" scoped>
.icon-form-field-group::v-deep {
    .icon-form-field-group__label {
        @apply inline-block font-bold mb-1;
    }
    .icon-form-field {
        @apply flex  w-full items-center mb-4;
    }

    .icon-form-field__icon {
        @apply w-1/5;
    }

    .icon-form-field__icon-image {
        @apply block rounded;
        max-width: $icon-form-field-icon-max-width;
    }

    .icon-form-field__data {
        @apply w-1/3 ml-6;
    }

    .icon-form-field__help {
        @apply ml-2;
        font-size: $font-tiny;
        color: $text-help-color;
    }
}
</style>
